var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
// import { Link } from 'react-router-dom'
import Button from '../button';
import Icon from '../icon';
import Popover from '../popover';
import { Styled } from './style';
var ToggleStar = /** @class */ (function (_super) {
    __extends(ToggleStar, _super);
    function ToggleStar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ToggleStar.prototype.render = function () {
        return (React.createElement(Styled, { className: "toggle-star" },
            React.createElement(Popover, { trigger: React.createElement(Button, { "data-testid": this.props['data-testid'] || 'toggle-star', disabled: this.props.disabled || false, className: "star", icon: true, toggle: true, active: this.props.active, onClick: this.props.onClick },
                    React.createElement(Icon, { name: "star" })), className: "star", content: this.props.active ? React.createElement("span", null, "Starred") : React.createElement("span", null, "Not Starred"), position: "top center", inverted: true })));
    };
    return ToggleStar;
}(React.Component));
export default ToggleStar;
//# sourceMappingURL=index.js.map